import React from 'react';
import PropTypes from 'prop-types';
import {get as _get} from 'lodash';

import Table from '@appComponents/Table';

import tableColumns from './EventsReportedAsWorkingAndInvoiceableColumns';
import tableRowRenderer from './EventsReportedAsWorkingAndInvoiceableRowRenderer';

export const EventsReportedAsWorkingAndInvoiceableTable = ({data = [], isLoading = true}) => {
    return (
        <div className='ui form'>
            <Table
                name='eventsPresetApply'
                columns={tableColumns}
                loading={isLoading}
                data={_get(data, 'events', [])}
                rowRenderer={tableRowRenderer}
                pagination={false}
                size='small'
                defaultSort={'start_datetime'}
            />
        </div>
    );
};

EventsReportedAsWorkingAndInvoiceableTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
};
